export default __webpack_public_path__ + "media/first_slide_video.03687da6.png";